<template>
    <canvas
        ref="canvas"
        @pointerdown="startDrawing"
        @pointerup="stopDrawing"
        @pointermove="draw"></canvas>
</template>

<script>
export default {
    name: 'pad-draw-field',
    props: {
        item: { type: Object },
        width: { type: Number },
        height: { type: Number, default: 150 },
        x: { type: Number, default: 0 },
        y: { type: Number, default: 0 }
    },
    data: () => ({
        ctx: null,
        drawing: false,
        erasing: false,
        lastX: 0,
        lastY: 0
    }),
    watch: {
        width: 'setWidth'
    },
    mounted() {
        this.ctx = this.$refs.canvas.getContext('2d')
        this.ctx.canvas.width = this.width || 200
        this.ctx.canvas.height = this.height
    },
    methods: {
        setWidth() {
            this.ctx.canvas.width = this.width
        },

        clear() {
            this.ctx.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height)
        },

        getBlob() {
            return new Promise(resolve => {
                this.$refs.canvas.toBlob(blob => resolve(blob))
            })
        },

        getYPos(ev) {
            var rect = this.$el.getBoundingClientRect()
            return rect.top
        },

        setImage(img) {
            this.ctx.drawImage(img, 0, 0)
        },

        draw(ev) {
            if (ev.pressure <= 0 || !this.drawing) {
                return
            }
            const xPosition = ev.clientX - this.x
            const yPosition = ev.clientY - this.getYPos(ev)
            this.ctx.beginPath()
            if (this.erasing) {
                this.ctx.lineWidth = 40 * ev.pressure
                this.ctx.strokeStyle = '#FFFFFF'
            } else {
                this.ctx.lineWidth = 5 * ev.pressure
                this.ctx.strokeStyle = '#000000'
            }
            this.ctx.moveTo(this.lastX, this.lastY)
            this.ctx.lineTo(xPosition, yPosition)
            this.ctx.stroke()
            this.lastX = xPosition
            this.lastY = yPosition
        },

        startDrawing(ev) {
            const xPosition = ev.clientX - this.x
            const yPosition = ev.clientY - this.getYPos(ev)
            this.drawing = true
            this.erasing = this.iAmAGummy(ev)
            this.lastX = xPosition
            this.lastY = yPosition
        },

        stopDrawing(ev) {
            this.lastX = 0
            this.lastY = 0
        },

        iAmAGummy(ev) {
            return ev.button === 5
        }
    }
}
</script>

<style lang="stylus" scoped>
canvas
    position: relative;
    touch-action: none;
    border: 1px solid #333;
    background-color: white;

</style>
